var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-logo" }, [
    _c("img", { attrs: { src: require("@/assets/images/company.png") } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }